import { style } from "@vanilla-extract/css";
import { vars } from "../../../styles/theme.css";

export const chipRowStyles = style({
  display: "flex",
  gap: vars.space.xs,
  overflowX: "auto",
  scrollBehavior: "smooth",
});
